module.exports = __webpack_public_path__ + "1d427519ecf7a1ef2d62d4bc6dde9f04.jpg";